import * as React from 'react';
import * as PropTypes from 'prop-types';

export default class Logout extends React.Component {

	static contextTypes = {
		router: PropTypes.func.isRequired
	}

	constructor(props) {
		super(props);
		this.logout = this.logout.bind(this);
	}

	logout() {
		localStorage.removeItem('studenttoken');
		window.location.href = '/login';
	}

	render() {
		return (
			<button onClick={this.logout} className="btn am_red-button">KIRJAUDU ULOS</button>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Common/logout.tsx